import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { deleteChildItems } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { ShoppingCartDTO } from '@t/api.types';

interface UseDeleteChildItemsOptions {
  onError?: (error: Error) => void;
}

export const useDeleteChildItems = (
  sessionId: string,
  { onError }: UseDeleteChildItemsOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, string[]> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, string[]>({
    mutationFn: (childItemIds) => deleteChildItems(sessionId, childItemIds),
    onSuccess: (cart) => queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart),
    onError,
  });
};
